<template>
  <div>
    <b-form-select v-model="group" :options="grups_select" data-live-search="true" class="mb-3">
      <template slot="first">
        <option v-if="newTicket" :value="null" selected disabled>-- Selecciona una subcategoria --</option>
      </template>
    </b-form-select>
  </div>
</template>

<script>
export default {
  props: {
    newTicket: {
      required: false,
      type: Boolean
    },
    grup: {
      required: false,
      type: Object
    },
    category: {
      required: true
    }
  },
  computed: {
    groups () {
      return this.$store.state.groups
    }
  },
  data () {
    return {
      selected: null,
      // Arrays del select
      grups_select: [],
      // Información escogida por el usuario
      group: this.grup ? this.grup.id : null
    }
  },
  created () {
    // Cogemos los grupos y las formateamos para que se vean en el select
    if (this.newTicket) {
      this.$store.dispatch('fetchGroups')
    } else {
      this.$store.dispatch('fetchGroups').then(() => {
        this.grups_select = this.groups.filter(grup => grup.id_categoria === this.category).map(grup =>
          ({
            value: grup.id,
            text: grup.descripcio
          }))
        return this.groups_select
      }, {})
    }
  },
  watch: {
    category: function (newVal) {
      if (newVal != null) {
        this.grups_select = this.groups.filter(
          group => group.id_categoria === this.category
        ).map(group => ({
          value: group.id,
          text: group.descripcio
        }))
      }
      this.group = null
    },
    // Cuando seleccione un grupo filtramos y aviso al elemento parent para que pille la info
    group: function (newId) {
      if (newId != null) {
        this.$emit('changeGroup', {
          id: newId,
          descripcio: this.group.descripcio
        })
      } else {
        this.$emit('changeGroup', null)
      }
    }
  }
}
</script>

<style scoped>

</style>
